import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminContext } from '../../components/self-service/admin/useAdminContext';

// CTV-787: the Team sidebar item became the Team tab of Station settings.
// The old URL stays reachable (bookmarks, links in older invite emails) and
// lands on the Team tab with its query string intact. The Settings layout
// owns the manager gate.
const PublisherTeamRedirectPage: React.FC = () => {
  const ctx = useAdminContext();
  const { search } = useLocation();
  const slug = ctx.mode === 'aggregated' ? ctx.collapseSlug : ctx.slug;
  return <Navigate to={{ pathname: `/admin/${slug}/settings/team`, search }} replace />;
};

export default PublisherTeamRedirectPage;
